<template>
  <div v-if="isShowPage">
    <div class="order-detail" ref="orderDetail" v-if="isList">
      <div class="tab-box">
        <div class="tab-item" @click="goNextPage">活动订单</div>
        <div class="tab-item cur">商城意向单</div>
      </div>
      <div class="card-box" >
          <OrderCard :payerDisabled="!isTerms" :MajorGuestID="MajorGuestId"
                     :countries="countries"
                     :payList="listData.BookingGuests"
                     :bookingContact="bookingContact"
                     :displayOrder="displayOrder"
                     :orderInChange="orderInChange"
                     @checkName="checkNames"
                     @checkContacts="checkContacts"/>
      </div>
      <div v-show="orderShow">
        <ShoppingCartCard v-show="cosmeticItems.length>0" cardTitle="日妆店">
          <EnterainmentCard :cardData="cosmeticItems" />
        </ShoppingCartCard>
        <ShoppingCartCard v-show="retailItems.length>0" cardTitle="免税店">
          <EnterainmentCard :cardData="retailItems" />
        </ShoppingCartCard>
        <!--合计-->
        <div class="card-box">
          <div class="total-box flex-center-box card-cell">
            <div class="title">总计：</div>
            <div class="price"><span class="price-color">{{priceFormat(total)}}</span> 美元</div>
          </div>
        </div>

        <!--皇家行前条款-->
        <div class="card-box" v-if="isTerms">
          <TermsCard :termsCheck.sync="termsCheck"/>
        </div>

        <!--提交订单-->
        <div v-show="isFromCart || !orderChange">
          <van-button class="bottom-btn" block @click="submitOrder('submit')" v-if="isTerms">提交订单</van-button>
          <van-button class="bottom-btn" block @click="submitOrder('change')" v-else>更改意向单</van-button>
        </div>
        <van-button v-show="!isFromCart && orderChange" class="bottom-btn toCart" block @click="goCart()">
          您的意向单有新增修改，请去<span class="underline">意向单</span>确认<br/>如未确认，保留原意向单
        </van-button>
      </div>
    </div>
    <EmptyShoppingCart v-if="!isShowPage"/>
  </div>
</template>

<script>
import EnterainmentCard from './shopping_cart/OrderDetailCard'
import OrderCard from './order_detail/OrderCard'
import TermsCard from './order_detail/TermsCard'
import ShoppingCartCard from './shopping_cart/ShoppingCartCard'
import EmptyShoppingCart from './shopping_cart/EmptyShoppingCart'
import api from '@/api'
import { showLoading, hideLoading, showAlert, checkTel, checkMail } from '@/utils/tools'
import { mapState } from 'vuex'
// import groupBy from 'lodash/groupBy'
import { Dialog } from 'vant'
import { checkLoginStatus, gioTracking } from '@/plugins/common.js'
export default {
  name: 'PageOrderDetail',

  components: {
    EnterainmentCard,
    OrderCard,
    TermsCard,
    ShoppingCartCard,
    EmptyShoppingCart
  },

  data () {
    return {
      isTerms: false,
      listData: {},
      shopCartItems: {},
      cosmeticItems: [],
      retailItems: [],
      termsCheck: false,
      MajorGuestId: '',
      isList: false,
      total: 0,
      cancelOrder: 0,
      isShowPage: true,
      orderShow: false,
      orderChange: false,
      isFromCart: false,
      countries: null,
      bookingContact: null
    }
  },
  computed: {
    ...mapState(['bindTicket', 'bookingContactInfo', 'goodsCartNum'])
  },
  filters: {

  },
  created() {
    this.getCallingCode();
  },
  mounted () {
    this.isShowPage = true
    const { isFromCart } = this.$route.query
    if (isFromCart === 'true') {
      this.isFromCart = true
    }
    checkLoginStatus().then(() => {
      this.checkOrdersStatus()
    })
  },

  methods: {
    priceFormat (current) {
      return current && current !== '' ? current.substr(0, current.length - 2) : current
    },
    displayOrder () {
      this.orderShow = true
    },
    orderInChange () {
      this.orderChange = true
    },
    goNextPage () {
      window.location.href = process.env.VUE_APP_MB + '/Rccl.PCP/Order/Checkout'
    },
    goCart () {
      this.$router.push('/cart')
    },
    // 判断来源，读取不同订单内容接口
    async getOrderFrom () {
      if (this.isFromCart) {
        this.getOrderInfo()
        if (this.goodsCartNum && this.goodsCartNum !== 0) {
          this.isTerms = true
        } else {
          this.isTerms = false
        }
      } else {
        this.getOriginOrderInfo()
      }
    },
    // 提交订单
    submitOrder (val) {
      let bookingContact = this.bookingContact;
      console.log(bookingContact)
      if(!bookingContact.bookingContactName) {
        showAlert('请填写联系人').then(() => {
          window.scroll({ top: 0, left: 0, behavior: 'smooth' })
        });
        return;
      }
      if(!bookingContact.telephone) {
        showAlert('请填写手机号').then(() => {
          window.scroll({ top: 0, left: 0, behavior: 'smooth' })
        });
        return;
      }
      if(bookingContact.callingCode === '86' && (bookingContact.telephone.length < 11 || !checkTel(bookingContact.telephone))) {
        showAlert('请输入正确的手机号码').then(() => {
          window.scroll({ top: 0, left: 0, behavior: 'smooth' })
        });
        return;
      }
      if(!bookingContact.email) {
        showAlert('请填写邮箱').then(() => {
          window.scroll({ top: 0, left: 0, behavior: 'smooth' })
        });
        return;
      }
      if(!checkMail(bookingContact.email)) {
        showAlert('请输入正确的邮箱').then(() => {
          window.scroll({ top: 0, left: 0, behavior: 'smooth' })
        });
        return;
      }

      if (val === 'submit') {
        if (this.termsCheck) {
          gioTracking('track', 'evt_submitOrder', {
            PCPOrderID: this.cancelOrder,
            productCount: this.goodsCartNum
          })
          this.setPayPerson()
          this.setBookingContact();
          this.submitSMOrder()
        } else {
          showAlert('请阅读并确认条款').then(() => {
            window.scroll({ top: this.$refs.orderDetail.clientHeight, left: 0, behavior: 'smooth' })
          })
        }
      } else {
        Dialog.confirm({
          message: '请确认是否需要修改订单'
        }).then(() => {
          this.updateSMOrder()
        })
      }
    },
    // 预定支付人
    checkNames (val) {
      this.MajorGuestId = val
    },
    // 联系人信息
    checkContacts (value) {
      switch (value.key) {
        case 'telephone':
          this.bookingContact.telephone = value.val;
          break;
        case 'callingCode':
          this.bookingContact.callingCode = value.val;
          break;
        case 'bookingContactName':
          this.bookingContact.bookingContactName = value.val;
          break;
        default:
          this.bookingContact.email = value.val || null;
          break;
      }
    },
    // 获取订单列表API
    async getOrderInfo () {
      showLoading()
      const { errCode, errMsg, data } = await api.getSMOrderDetail()
      hideLoading()
      if (errCode === 0) {
        if (data) {
          this.listData = data
          this.total = data.SMShoppingCart.SMOrderTotals.SubTotal
          this.cosmeticItems = data.SMShoppingCart.CosmeceuticalItems
          this.retailItems = data.SMShoppingCart.RetailItems
          this.cancelOrder = data.OrderId
          if (data.GuestsId == null || data.GuestsId == 0) {
            this.MajorGuestId = data.BookingGuests[0].Value
          } else {
            this.MajorGuestId = data.GuestsId
          }
          if (data && data.SMShoppingCart.Items && data.SMShoppingCart.Items.length > 0) {
            this.isList = true
          } else {
            this.isList = false
          }
          this.setPayPerson()
          this.setBookingContact()
        }
      } else {
        showAlert(errMsg)
      }
    },
    // 获取已提交订单API
    async getOriginOrderInfo () {
      showLoading()
      const { errCode, errMsg, data } = await api.getSMOriginOrderDetail()
      hideLoading()
      if (errCode === 0) {
        if (data) {
          this.listData = data
          this.total = data.SMShoppingCart.SMOrderTotals.SubTotal
          this.cosmeticItems = data.SMShoppingCart.CosmeceuticalItems
          this.retailItems = data.SMShoppingCart.RetailItems
          this.cancelOrder = data.OrderId
          if (data.GuestsId === null || data.GuestsId === 0) {
            this.MajorGuestId = data.BookingGuests[0].Value
          } else {
            this.MajorGuestId = data.GuestsId
          }
          if (data && data.SMShoppingCart.Items && data.SMShoppingCart.Items.length > 0) {
            this.isList = true
          } else {
            this.isList = false
          }
          this.setPayPerson()
          this.setBookingContact()
        }
      } else {
        showAlert(errMsg)
      }
    },
    // 获取购物车列表
    async getShoppingCartInfo () {
      showLoading()
      const { errCode, errMsg, data } = await api.getShoppingCartsList()
      if (errCode === 0) {
        if (data) {
          this.getGuest()
          this.total = data.SMOrderTotals.SubTotal
          this.cosmeticItems = data.CosmeceuticalItems
          this.retailItems = data.RetailItems
          this.isList = true
          this.cartNumber = 0
          data.Items.map(item => {
            this.cartNumber = this.cartNumber + item.ShoppingCartItemModel.Quantity
          })
        }
      } else {
        showAlert(errMsg)
        this.isList = false
      }
      hideLoading()
    },
    async getGuest () {
      const { errCode, errMsg, data } = await api.getSMOrderDetail()
      if (errCode === 0) {
        if (data) {
          this.listData = data
          if (data.GuestsId === null || data.GuestsId === 0) {
            this.MajorGuestId = data.BookingGuests[0].Value
          } else {
            this.MajorGuestId = data.GuestsId
          }
          this.setPayPerson()
        }
      } else {
        showAlert(errMsg)
      }
    },
    // 重制预定支付人
    setPayPerson () {
      const guestsData = this.listData.BookingGuests
      guestsData.some((curitem, index, arr) => {
        if (curitem.Value === this.MajorGuestId) {
          this.$store.state.bindTicket.pinyinLastName = curitem.Text
          this.$store.state.bindTicket.pinyinFirstName = ''
        }
      })
    },
    // 重制联系人
    setBookingContact() {
      const bookingContactInfo = this.bookingContact;
      this.$store.state.bookingContactInfo = Object.assign({}, bookingContactInfo)
    },
    // 提交商城订单API
    async submitSMOrder () {
      showLoading()
      let guestId = parseInt(this.MajorGuestId)
      let cancelOrder = this.cancelOrder
      let bookingContact = this.bookingContact
      let params = {
        cancelOrder: cancelOrder,
        guestId: guestId,
        email: bookingContact.email,
        mobile: bookingContact.telephone,
        callingCode: bookingContact.callingCode,
        bookingContactName: bookingContact.bookingContactName
      }
      const { errCode, errMsg } = await api.submitSMOrder(params)
      hideLoading()
      if (errCode === 0) {
        this.$router.push('/SMOrder/CurrentOrder')
        this.$store.commit('store', {
          goodsCartNum: 0
        })
      } else {
        showAlert(errMsg)
      }
    },
    // 更改商城订单
    async updateSMOrder () {
      showLoading()
      const { errCode, errMsg } = await api.updateSMOrder()
      if (errCode === 0) {
        this.$router.push('/cart')
      } else {
        showAlert(errMsg)
      }
    },
    // 订单状态查询
    async checkOrdersStatus () {
      showLoading()
      const { errCode, errMsg, data } = await api.checkSMOrderStatus()
      hideLoading()
      if (errCode === 0 && data) {
        if (data.orderId === 0) {
          api.getBookingInfo().then((res) => {
            if (res.errCode === 0) {
              this.bookingContact = Object.assign({
                bookingContactName: res.data.bookingContact.chineseLastName + res.data.bookingContact.chineseFirstName
              }, res.data.bookingContact);
              this.getShoppingCartInfo()
            } else {
              this.isShowPage = false
              showAlert(res.errMsg)
            }
          }).catch(error => {
            console.log(error)
          })
          this.isTerms = true
        } else {
          api.getBookingInfo().then((res) => {
            if (res.errCode === 0) {
              this.bookingContact = Object.assign({
                bookingContactName: res.data.bookingContact.chineseLastName + res.data.bookingContact.chineseFirstName
              }, res.data.bookingContact);;
              this.getOrderFrom()
            } else {
              this.isShowPage = false
              showAlert(res.errMsg)
            }
          }).catch(error => {
            console.log(error)
          })
        }
      } else {
        showAlert(errMsg).then(() => {
          this.$router.push(this.$store.getters.isLogin ? '/bind_ticket' : '/login')
        })
      }
    },
    async getCallingCode () {
      showLoading()
      const { errCode, errMsg, data } = await api.getCallingCode()
      hideLoading()
      if (errCode === 0) {
        if (data.rows && data.rows.length > 0) {
          this.countries = data.rows;
        }
      } else {
        showAlert(errMsg || '获取区号失败，请稍后重试')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.order-detail{
  padding: 57px 50px 127px;
  .tab-box {
    background-color: #e8ecef;
    border-radius: 10Px 10Px 0 0;
    font-size: 30px;
    color: #999999;
    text-align: center;
    display: flex;
    justify-content: center;
    overflow: hidden;
    .tab-item {
      padding: 20px 0;
      width: 50%;
      &.cur{
        color: #001366;
        background: url(../assets/order_detail_tab_cur_bj.png) no-repeat center;
        background-size: cover;
      }
    }
  }
  .card-box{
    margin-bottom: 20px;
  }
  ::v-deep .card-cell {
    background-color: #ffffff;
    border-radius: 6px;
    overflow: hidden;
    font-size: 18px;
    color: @main-gray4;
    line-height: 1.8;
    // .item-top-tag{
    //   font-size: 24px;
    //   color: @main-gray3;
    //   padding: 5px 20px;
    //   background-color: #f0f0f0;
    //   margin-bottom: 20px;
    //   display: inline-block;
    //   border-radius: 46px;
    // }
    .card-hd {
      font-size: 30px;
      color: @main-gray2;
      padding: 20px;
      border-bottom: 1px solid @main-gray5;
    }
    .card-bd{
      min-height: 100px;
    }
  }
  ::v-deep .item-btn{
    width: 85px;
    height: 46px;
    line-height: 46px;
    background-color: #1174b8;
    color: #ffffff;
    display: inline-block;
    text-align: center;
    margin-right: 10px;
    border-radius: 6px;
    font-size: .18rem;
    padding: 0;
    border:none;
    &.btn-linear-gradient{
      color: @main-gray2;
    }
  }
  ::v-deep .price-color{
    color: @second-color;
    font-weight: bold;
  }
  ::v-deep .blue-color{
    color: #1174b8;
  }
  ::v-deep .van-checkbox__icon{
    width: .28rem;
    height: .28rem;
    img{
      width: 100%;
      vertical-align: top;
    }
  }
  .bottom-btn{
    position: fixed;
    bottom: 126px;
    left: 0;
    right: 0;
    height: 117px;
    background-color: @second-color;
    color: #ffffff;
    line-height: 117px;
    text-align: center;
    font-size: 30px;
    z-index: 90;
  }
  .toCart {
    font-size: 28px;
    line-height: 40px;
    .underline {
      color: #1174b8;
      text-decoration: underline;
    }
  }
  .total-box{
    font-size: 24px;
    padding: 20px 30px;
    color: @main-gray2;
    .price{
      color: @main-gray4;
      .price-color{
        font-size: 36px;
      }
    }
  }
}
</style>
